import { render, staticRenderFns } from "./agency-freezer.vue?vue&type=template&id=3eacba3a&scoped=true&"
import script from "./agency-freezer.vue?vue&type=script&lang=js&"
export * from "./agency-freezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eacba3a",
  null
  
)

export default component.exports